<template>
  <div id="code-sheet-self" class="code-sheet-con">
    <img class="code-box" :src="codeUrl" v-if="codeUrl" />
    <div class="header">
      <div class="header-top">
        <div class="header-top_logo">
          <img
            alt="百布"
            src="../../../assets/baibu/bailu-logo.png"
          >
        </div>
        <h1 class="header-top_title">细码单</h1>
        <!--<div class="header-top_address">
          <p>全国统一服务热线：400-068-0040</p>
          <p>展厅地址：广州市海珠区新滘西路533号鸿洲国际轻纺城9层</p>
        </div>-->
      </div>
      <div class="header-bot base-style02">
        <div class="header-bot_l">
          <div>
            客户公司：<strong class="base-style03">{{ orderInfo.factoryName }}</strong>
          </div>
          <div>
            客户名称：
            <strong class="base-style03">
              {{ orderInfo.buyerName }} &nbsp;{{ orderInfo.buyerMobile }}
            </strong>
          </div>
        </div>
        <div class="header-bot_con">
          <div>
            货款类型：<strong class="base-style03">{{ orderInfo.paymentMethod }}</strong>
          </div>
          <div>
            <div v-if="!['2', 2].includes(orderInfo.shipType)">
              物流名称：<strong class="base-style03">{{ orderInfo.logisticsName }}</strong>
            </div>
            <div v-else>
              仓库名称：<strong class="base-style03">{{ orderInfo.wareHouseName }}</strong>
            </div>
          </div>
        </div>
        <div class="header-bot_r">
          <div class="header-bot_rtxtbox">
            <span>订单编号：</span>
            <strong class="header-bot_rtxt base-style03">{{ orderInfo.orderId }}</strong>
          </div>
          <div class="header-bot_rtxtbox">
            <span>下单时间：</span>
            <strong class="header-bot_rtxt base-style03">
              {{ orderInfo.createTime | formatTime }}
            </strong>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <table>
        <thead>
          <tr>
            <th
              v-for="(item, index) in tableTitle"
              :key="index"
              :style="{width: item.styleCss}"
            >
              {{item.name}}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in products">
            <tr :key="index">
              <td>{{ item.no }}</td>
              <td>{{ item.productNo }}</td>
              <td v-if="!IS_COLOR_CLOTH">{{ item.goodsColorSystem }}</td>
              <td>
                {{ item.colorNo }}
                <span v-if="item.goodsColorDesc">
                  &nbsp;{{ item.goodsColorDesc }}
                </span>
              </td>
              <td
                v-for="(x, index02) in item.deliverys[0]"
                :key="index02"
              >
                {{ x }}
              </td>
              <td>{{ item.discountAmount }}</td>
              <td>{{ item.productAmount }}</td>
              <td>{{ item.saleUnit }}</td>
              <td>{{ item.salePrice }}</td>
              <td>{{ item.productMoney }}</td>
            </tr>
            <tr
              v-for="(x, index02) in item.deliverys.length - 1"
              :key="`${index02}deliverys${index}`"
            >
              <td></td>
              <td></td>
              <td></td>
              <td v-if="!IS_COLOR_CLOTH"></td>
              <td
                v-for="(z, index03) in item.deliverys[x]"
                :key="`${index03}deliverysItem`"
              >
                {{ z }}
              </td>
              <td
                v-for="(d, index03) in 5"
                :key="index03"
              >
              </td>
            </tr>
          </template>
          <tr
            v-for="(item, index) in emptyRows"
            :key="`${index}emptyRows`"
          >
            <td
              v-for="(item02, index02) in (IS_COLOR_CLOTH ? 13 : 14)"
              :key="index02"
            >
            </td>
          </tr>
          <tr>
            <td
              colspan="1"
              class="base-style02"
            ><span>总计</span></td>
            <td
              :colspan="IS_COLOR_CLOTH ? 3 : 4"
              class="base-style01"
            >总匹/件数：{{ deliveryCount }}</td>
            <td
              colspan="5"
              class="base-style01"
            ><span class="base-style02">总数量：</span>{{ productAmount }}</td>
            <td
              colspan="4"
              class="base-style01"
            ><span class="base-style02">订单总额：</span>{{ orderInfo.realMoney }} 元</td>
          </tr>
          <tr>
            <td
              colspan="5"
              class="base-style01"
            >
              <span class="base-style02">金额大写：</span>
              {{ orderInfo.realMoney | convertCurrency}}
            </td>
            <td
              colspan="4"
              class="base-style01"
            >
              <span class="base-style02">已付金额: </span>{{ payment || '0' }}元
            </td>
            <td
              :colspan="IS_COLOR_CLOTH ? 4 : 5"
              class="base-style01"
            >
              <span class="base-style02">待付金额：</span>{{ buyerReceipt.noReceipt || '0' }}元
            </td>
          </tr>

          <tr v-if="!['2', 2].includes(orderInfo.shipType)">
            <td
              colspan="2"
              style="text-align:center;"
              class="base-style02"
            >
              收货地址
            </td>
            <td
              :colspan="IS_COLOR_CLOTH ? 11 : 12"
              style="line-height: 15px;"
              class="base-style03"
            >
              {{ orderInfo.consigneeAddress }}
              ({{ orderInfo.consignee }}&nbsp;&nbsp;
              {{ orderInfo.consigneeMobile }})
            </td>
          </tr>
          <tr v-else>
            <td
              colspan="2"
              style="text-align:center;"
              class="base-style02"
            >
              自提地址
            </td>
            <td
              :colspan="IS_COLOR_CLOTH ? 11 : 12"
              style="line-height: 15px;"
              class="base-style03"
            >
              {{ orderInfo.wareHouseAddr }}
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="text-align:center;"
              class="base-style02"
            >备注</td>
            <td
              :colspan="IS_COLOR_CLOTH ? 11 : 12"
              style="line-height: 16px;"
              class="base-style03"
            >
              {{ orderInfo.codeDesc }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="footer">
      <div class="footer-main">
        <div class="footer-main_i">业务员：{{ orderInfo.workerName }}</div>
        <div class="footer-main_i">经手人：{{ orderInfo.guiderBbCode }}</div>
        <div class="footer-main_i">收货人签名：</div>
      </div>
      <p class="base-style02">
        注意：本凭证所载货物如有质量问题，请于本凭证确认签收之日起5日内，将货物退回我司检验处理。
        逾期提出退换要求、已裁剪或加工（缩水、洗水、印花等后工艺加工）的货物，本司恕不负责协调处理退换货事宜
      </p>
    </div>
  </div>
</template>

<script>
import { Notify } from 'vant';
import {
  getDirectSaleOrderDetails,
  getDirectSaleFinanceDetails,
  getQrCodeContent,
} from '@/api/baibu';
import NP from 'number-precision';
import { formatTableList } from '@/utils';
import QRCode from 'qrcode';

export default {
  name: 'CodeSheet',
  props: {
    sourceType: {
      type: String,
      default: '2', // 3:大客户，2:直销
    },
    orderId: {
      type: String,
      default: '',
    },
    workerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      codeUrl: '',
      IS_COLOR_CLOTH: true,
      tableTitle: [
        { styleCss: '95px', name: '商品编码' },
        { styleCss: '76px', name: '货号' },
        { styleCss: '78px', name: '色号' },
        { styleCss: '38px', name: '1' },
        { styleCss: '38px', name: '2' },
        { styleCss: '38px', name: '3' },
        { styleCss: '38px', name: '4' },
        { styleCss: '38px', name: '5' },
        // { styleCss: '4%', name: '6' },
        // { styleCss: '4%', name: '7' },
        // { styleCss: '4%', name: '8' },
        // { styleCss: '4%', name: '9' },
        // { styleCss: '4%', name: '10' },
        { styleCss: '40px', name: '优惠' },
        { styleCss: '53px', name: '数量' },
        { styleCss: '38px', name: '单位' },
        { styleCss: '39px', name: '单价' },
        { styleCss: '62px', name: '金额' },
      ],
      products: [], // 订单商品信息
      orderInfo: {
        factoryName: '', // 客户公司
        paymentMethod: '', // 货款类型
        orderId: '', // 订单编号
        buyerName: '', // 客户名称
        buyerMobile: '', // 客户电话
        logisticsName: '', // 物流名称
        createTime: null, // 下单时间
        codeDesc: '', // 备注
        workerName: '', // 业务员
        realMoney: null, // 订单总额
        operator: '', // 经手人
        guiderBbCode: '', // 经手人code

        // 2020-04-02 电子码单修改新加的
        shipType: '', // 配送类型
        consigneeAddress: '', // 收货地址
        consignee: '', // 收货人
        consigneeMobile: '', // 收货电话
        wareHouseName: '', // 仓库名称
        wareHouseAddr: '', // 仓库地址
      },
      buyerReceipt: {
        shouldReceipt: null, // 实收金额
        noReceipt: null, // 待收金额
      },
    };
  },

  created() {
    const q1 = this.getDirectSaleOrderDetails();
    const q2 = this.getDirectSaleFinanceDetails();
    const q3 = this.getQrCodeContent();
    
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
      // loading
      message: '码单生成中，请稍候...',
    });
    Promise.all([q1, q2, q3]).then((result) => {
      const [OrderRes, FinanceRes] = [result[0], result[1]];

      if (OrderRes.statusCode === 1 && FinanceRes.statusCode === 1) {
        OrderRes.data.sellers.forEach((item) => {
          const seller = {};

          // 转换供应商基本信息
          Object.keys(item.seller).forEach((obj) => {
            seller[obj] = item.seller[obj];
          });

          // 转换图片串为数组
          seller.sellerImgList = seller.sellerImg ? seller.sellerImg.split(',') : [];

          // 转换产品信息
          item.products.forEach((obj) => {
            let deliverys = [];
            if (obj.deliverys) {
              const isEmpty = obj.deliverys.split(',').filter((deliveryItem) => { return deliveryItem !== ''; }).length;
              deliverys = isEmpty ? obj.deliverys.split(',').filter((deliveryItem) => { return deliveryItem !== ''; }) : [''];
            } else {
              deliverys = [''];
            }
            obj.deliverys = deliverys;

            if (obj.productType.includes('花型') && this.IS_COLOR_CLOTH) {
              this.IS_COLOR_CLOTH = false;
              // 只进来一次
              this.tableTitle.splice(2, 0, { styleCss: '76px', name: '底布' });
            }
          });
          this.products = this.products.concat(JSON.parse(JSON.stringify(item.products)));
          
          this.products = formatTableList(this.products);
        });

        // 给码单经手人赋值
        OrderRes.data.operateList.forEach((item) => {
          if (item.status === 15) {
            this.orderInfo.operator = item.operator;
          }
        });

        // 订单详情赋值
        Object.keys(this.orderInfo).forEach((obj) => {
          if (obj !== 'operator') {
            this.orderInfo[obj] = OrderRes.data.base[obj];
          }
        });
        // 账务详情赋值
        Object.keys(this.buyerReceipt).forEach((obj) => {
          this.buyerReceipt[obj] = FinanceRes.data.buyerReceipt[obj];
        });
      } else {
        Notify({ message: '出错啦，请重试！' });
      }

      this.$nextTick(() => {
        this.$emit('success');
      });

      
      this.$toast.clear();
    });
  },

  mounted() {},

  computed: {
    // 已付金额
    payment() {
      return NP.strip(this.buyerReceipt.shouldReceipt - this.buyerReceipt.noReceipt);
    },

    // 保证表格最少6行内容
    emptyRows() {
      let rows = 6;
      this.products.forEach((p) => {
        rows -= p.deliverys.length;
      });
      return rows < 0 ? 0 : rows;
    },

    // 总匹/件数
    deliveryCount() {
      let deliveryCount = 0;
      this.products.forEach((obj) => {
        deliveryCount += obj.deliveryCount;
      });
      return deliveryCount;
    },

    // 总数量
    productAmount() {
      let productAmount = 0;
      this.products.forEach((obj) => {
        productAmount += obj.productAmount * 1000;
      });
      return productAmount / 1000;
    },
  },

  components: {},

  methods: {
    getQrCodeContent() {
      return new Promise((resolve, reject) => {
        getQrCodeContent({
          orderId: this.orderId,
          orderCode: this.orderId,
          printType: 'BAIBU_ORDER',
          workerId: this.workerId,
          isNewOrder: 'NO',
        }).then((res) => {
          if (res.data) {
            const { contentType, content } = res.data;
            if (contentType !== 'APPLET_CODE') {
              this.creatQrCode(content, resolve, reject);
            } else {
              this.codeUrl = content;
            }
          } else {
            this.creatQrCode(this.orderId, resolve, reject);
          }
        }, () => {
          this.creatQrCode(this.orderId, resolve, reject);
        });
      });
    },
    creatQrCode(content, resolve, reject) {
      QRCode.toDataURL(content)
        .then((url) => {
          this.codeUrl = url;
          resolve();
        })
        .catch(() => {
          reject();
        });
    },
    // 获取订单详情-直销
    getDirectSaleOrderDetails() {
      return new Promise((resolve, reject) => {
        getDirectSaleOrderDetails({
          orderId: this.orderId,
          workerId: this.workerId,
        }).then((res) => {
          resolve(res);
        }).catch(() => {
          reject();
        });
      });
    },

    // 获取财务详情-直销
    getDirectSaleFinanceDetails() {
      return new Promise((resolve, reject) => {
        getDirectSaleFinanceDetails({
          orderId: this.orderId,
          workerId: this.workerId,
        }).then((res) => {
          resolve(res);
        }).catch(() => {
          reject();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .base-style03{
    font-weight: bold;
  }
  .base-style01{
    text-align: center;
    @extend .base-style03
  }
  .base-style02{
    font-weight: 500;
  }
  .code-sheet-con{
    position: relative;
    min-width: 799PX;
    padding: 26PX 58PX 22PX 58PX;
    font-size: 12PX;
    font-family: Microsoft YaHei, simsun, "宋体", sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    font-weight: 400;
    color: #000;
    box-sizing: border-box;
    .code-box{
      position: absolute;
      right: 58PX;
      top: 17PX;
      width: 64PX;
      height: 64PX;
    }
  }
  .header{
    &-top{
      display: flex;
      margin-bottom: 10PX;
      &_logo{
        width: 80PX;
      }
      &_title{
        // display: flex;
        // align-items: center;
        // justify-content: center;
        font-size: 32PX;
        font-weight: 600;
        margin-left: 40PX;
      }
      &_address{
        flex: 1;
        text-align: right;
        line-height: 16PX;
      }
    }
    &-bot{
      display: flex;
      line-height: 16PX;
      margin-bottom: 2PX;
      justify-content: space-between;
      // &_con{
      //   padding: 0 5PX;
      // }
      &_rtxt{
        flex: 1;
        text-align: right;
      }
      &_rtxtbox{
        display: flex;
      }
    }
  }
  .main{
    table{
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      border: 1PX solid #000;
      max-width: 100%;
      background-color: transparent;
      empty-cells: show;
      tr{
        th{
          height: 20PX;
          vertical-align: middle;
          padding: 2PX 3PX;
          vertical-align: top;
          border-right: 1PX solid #000;
          border-top: none;
          border-bottom: none;
          text-align: left;
          font-weight: bold;
          &:nth-last-child(1){
            border-right: none;
          }
        }
        td{
          padding: 2PX 3PX;
          border: 1PX solid #000;
          border-left: none;
          border-bottom: none;
          height: 21PX;
          &:nth-last-child(1){
            border-right: none;
          }
        }
      }
    }
  }
  .footer{
    &-main{
      display: flex;
      height: 20PX;
      line-height: 20PX;
      &_i{
        flex: 1;
      }
    }
    p{
      margin: 10PX 0 0;
      line-height: 16PX;
    }
  }
</style>
